import React, { useMemo } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Link, Navigate } from "react-router-dom";
import { useAppContext } from "../../context/AppContext";
import { SuccessTrans } from "../../utils/translations";
import Loader from "../utilPages/Loader";
import OnlineClubFlipCardsGrid from "../onlineClub/OnlineClubFlipCardsGrid";
import {
  TELEGRAM_ONLINE_CLUB_GUEST,
  TELEGRAM_ONLINE_CLUB_SUBSCRIBED,
} from "../Schedule/TelegramSection";
import "../../styles/landing.css";

export default function SuccessfulPayment() {
  const { isAuthenticated, isLoading: authLoading } = useAuth0();
  const { language, setToaster, isMobile, onlineClubContent } = useAppContext();

  const successPageCards = useMemo(
    () =>
      onlineClubContent.map((item) => {
        const next = { ...item, featured: false };
        if (item.link === "/constructor-trial") {
          next.link = "/constructor";
          next.button = SuccessTrans[language].successOnlineClubGoButton;
        }
        if (item.link === "/library") {
          next.button = SuccessTrans[language].successOnlineClubGoButton;
        }
        if (item.link === TELEGRAM_ONLINE_CLUB_GUEST) {
          next.link = TELEGRAM_ONLINE_CLUB_SUBSCRIBED;
          next.button = SuccessTrans[language].successOnlineClubPrivateChatButton;
        }
        return next;
      }),
    [onlineClubContent, language]
  );

  if (authLoading) {
    return <Loader load />;
  }
  if (!isAuthenticated) {
    return <Navigate to="/not-found" replace />;
  }

  return (
    <div className="w-full mx-auto my-12 px-4 font-sans antialiased">
      <h1 className="md:mt-o mt-16 text-2xl md:text-3xl mb-8 text-center text-ink">
        {SuccessTrans[language].payment}
      </h1>
      <div className="bg-warm-white/90 p-4 rounded-sm border border-sand-dark shadow-sm text-sm md:w-7/12 mx-auto text-ink-mid">
        <p className="text-center mb-4">
          {SuccessTrans[language].yourSub}
          <strong className="text-ink">{SuccessTrans[language].active}</strong>
          {SuccessTrans[language].welcome}
        </p>
        <p>{SuccessTrans[language].firstStep}</p>
      </div>

      <section className="mb-4 w-11/12 max-w-6xl mx-auto mt-10">
        <div className="bg-cream py-10 md:py-12 px-4 md:px-8 rounded-sm border border-sand-dark/30">
          <h2 className="font-serif text-2xl md:text-3xl font-medium text-ink text-center mb-10">
            {SuccessTrans[language].whatsAvailable}
          </h2>
          <OnlineClubFlipCardsGrid
            items={successPageCards}
            language={language}
            isMobile={isMobile}
            setToaster={setToaster}
          />
        </div>
      </section>

      <p className="text-center mt-3">
        <Link
          to="/profile"
          className="text-clay font-semibold border-b border-clay pb-0.5 hover:opacity-80 focus:outline-none focus:ring-2 focus:ring-clay/40 rounded"
        >
          {SuccessTrans[language].account}
        </Link>
      </p>
    </div>
  );
}
